/* global Splide */
"use strict";

($dt => {
	
	$dt.blocks['standard-one-column'] = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			
			const slider = container.querySelector('.splide');
			
			if (slider) {
				const options = {
					type: 'loop',
					autoplay: true,
					interval: 10000,
					pauseOnHover: true,
					pauseOnFocus: true
				};
				
				new Splide(slider, options).mount();
			}
		}
		
	};
	
})(window.d3_wp_themejs);
